"use client";
import React, { useState, useEffect, useRef } from 'react';
import { MotionValue, motion } from "framer-motion";
import { AnimatePresence, useScroll, useTransform } from 'framer-motion';
import Preloader3 from '../preloader3';
import Header from '../header';
import LocomotiveScroll from 'locomotive-scroll';
import Footer from 'components/footer/two/footer';
import { Outlet } from 'react-router-dom';
import { detailProjects } from '../../data';
import Slider from '../slider';


export default function LayoutThree() {
    const [isLoading, setIsLoading] = useState(true);
    const container = useRef<HTMLElement | null>(null);
    const words = ["PORTOfolio", "PORTEfeuille"];

    const { scrollYProgress } = useScroll({
        target: container,
        offset: ["start start", "end end"]
    })

    useEffect(() => {
        (
            async () => {
                const locomotiveScroll = new LocomotiveScroll();

                setTimeout(() => {
                    setIsLoading(false);
                    window.scrollTo(0, 0);
                }, 2000)
            }
        )()
    }, []);

    return (
        <>
            <AnimatePresence mode='wait'>
                {isLoading &&
                    <Preloader3 words={words} />
                }
            </AnimatePresence>
            <Header titleClass={true} />
            <Outlet />
            <Slider portfolios={detailProjects} sliderClass="bg-smoke pt-12 md:pt-24 4xl:pt-32 4xl:pb-32 pb-5 md:pb-12 lg:pb-24 lg:pt-48" />
            <Footer />
        </>
    );
}

